import { Component } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Box } from 'foundations-components/transitional/components/Box';
import { LoadingSpinner } from 'foundations-components/transitional/components/LoadingSpinner';
import { PUBLISHING_OVERLAY_WIDTH } from '../../constants/ModalConstants';
import { Text } from 'foundations-components/components/Text';
import { Overlay } from 'foundations-components/transitional/components/Overlay';
import { Flex } from 'foundations-components/components/Flex';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
class PublishingOverlay extends Component {
  render() {
    return /*#__PURE__*/_jsx(Overlay, {
      width: PUBLISHING_OVERLAY_WIDTH,
      children: /*#__PURE__*/_jsx(Flex, {
        alignItems: "center",
        flexDirection: "column",
        justifyContent: "center",
        blockSize: `${window.innerHeight}px`,
        children: /*#__PURE__*/_jsxs(Box, {
          alignSelf: "start",
          children: [/*#__PURE__*/_jsx(LoadingSpinner, {
            grow: true
          }), /*#__PURE__*/_jsx(Text, {
            as: "h5",
            marginBlockStart: "400",
            color: "text-core-on-fill-default",
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "knowledgeContentUI.shared.publishing"
            })
          })]
        })
      })
    });
  }
}
export default PublishingOverlay;